import {
  FILE_SIZE_LIMIT_MB_ANTHROPIC,
  FILE_SIZE_LIMIT_MB_PAID_TIER,
  FILE_SIZE_LIMIT_MB_PERSONAL_TIER,
} from '~/utils/constants';
import type { EffectiveTier } from '~/utils/effectiveTier';

export function mbToBytes(mb: number) {
  return mb * 1024 * 1024;
}

export function getFileSizeLimitMB({
  tier,
  target,
}: {
  tier: EffectiveTier | undefined;
  target: 'anthropic' | 'bolt';
}) {
  if (!tier) {
    return FILE_SIZE_LIMIT_MB_ANTHROPIC;
  }

  if (target === 'anthropic') {
    return FILE_SIZE_LIMIT_MB_ANTHROPIC;
  }

  if (tier.level === 0) {
    return FILE_SIZE_LIMIT_MB_PERSONAL_TIER;
  }

  return FILE_SIZE_LIMIT_MB_PAID_TIER;
}

export function getFileSizeLimit({ tier, target }: { tier: EffectiveTier | undefined; target: 'anthropic' | 'bolt' }) {
  const mb = getFileSizeLimitMB({ tier, target });

  return {
    bytes: mbToBytes(mb),
    mb,
  };
}
